import React from 'react';
import logo from '../logo.png';

function Navigation() {
    return (
        <nav className="site-nav">
            <div className="dt-container site-nav__inner">
                <a href="/" className="site-nav__brand">
                    <img src={logo} alt="Dark Transport" />
                    <span>Dark Transport</span>
                </a>
                <div className="site-nav__links">
                    <a href="#problem">The problem</a>
                    <a href="#features">Features</a>
                    <a href="#how-it-works">How it works</a>
                    <a href="#tiers">Tiers</a>
                    <a href="#notify">Updates</a>
                </div>
                <div className="site-nav__cta">
                    <a href="#notify" className="btn-primary-cta btn-sm">Contact us</a>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;
